module.exports = __webpack_public_path__ + "img/dun.1ab589a4.svg";